import { Typography } from "@mui/material"
import BankIcon from "../BankIcon"
import IconBox from "../IconBox"
import { BankItemProps } from "./props"
import UIIcon from "../UIIcon"
import { ItemContainer, ItemDescriptionContainer } from "../styled"

const BankItem = ({ description, bank, endIcon, ...rest }: BankItemProps) => (
  <ItemContainer {...rest}>
    <IconBox>
      <BankIcon logoUrl={bank.logoUrl} size="100%" />
    </IconBox>
    <ItemDescriptionContainer>
      <Typography variant="h4">{bank.title}</Typography>
      {description && <Typography variant="h6">{description}</Typography>}
    </ItemDescriptionContainer>
    {endIcon && <UIIcon iconName={endIcon} />}
  </ItemContainer>
)

export default BankItem
